import React from "react";
import PropTypes from "prop-types";

import Article from "../Main/Article";
import PostHeader from "./PostHeader";
import Content from "../Main/Content";
import PostFooter from "./PostFooter";

import config from "../../../content/meta/config";

const Post = props => {
  const { author, slug, disqus, facebook } = props;
  const post = props.post || {};
  const { id: identifier, title, subTitle, category } = post.frontmatter || {};
  const date = (post.fields || {}).prefix;

  return (
    <Article>
      <PostHeader {...{title, subTitle, category, date, timeToRead: post.timeToRead}} />
      <Content html={post.html} />
      <PostFooter {...{post, slug, facebook}}
        author={{...author, name: config.authorName}}
        disqus={{...disqus, identifier, title, url: config.siteUrl + slug}} />
    </Article>
  );
};

Post.propTypes = {
  post: PropTypes.object.isRequired,
  author: PropTypes.object.isRequired,
  slug: PropTypes.string.isRequired,
  disqus: PropTypes.object.isRequired,
  facebook: PropTypes.object.isRequired,
};

export default Post;



// WEBPACK FOOTER //
// ./src/components/Post/Post.js